import {
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import logo from "../assets/BurjLogo.jpg";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  HomeRounded,
  InfoRounded,
  BuildRounded,
  Inventory2Rounded,
  BusinessCenterRounded,
  PhotoLibraryRounded,
  ArticleRounded,
  WorkRounded,
  CallRounded,
} from "@mui/icons-material";

const brandBlue = "#1a237e";
const brandRed = "#d50000";

const Navbar = () => {
  // Dropdown menus
  const [anchorAbout, setAnchorAbout] = useState(null);
  const [anchorServices, setAnchorServices] = useState(null);
  const [anchorProducts, setAnchorProducts] = useState(null);
  const [anchorMore, setAnchorMore] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  // Mobile Drawer
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleMenuOpen = (setter) => (event) => setter(event.currentTarget);
  const handleMenuClose = (setter) => () => setter(null);

  return (
    <>
      {/* ---------------------------------------------------------------------- */}
      {/* DESKTOP NAVBAR */}
      {/* ---------------------------------------------------------------------- */}
      <AppBar
        position="sticky"
        sx={{
          backgroundColor: scrolled ? "rgba(255, 255, 255, 0.5)" : "#fff",
          backdropFilter: scrolled ? "blur(3px)" : "none",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          color: brandBlue,
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          {/* LOGO */}
          <Box
            component={RouterLink}
            to="/"
            style={{ textDecoration: "none" }}
            sx={{
              display: "flex",
              alignItems: "center", // Align logo + text vertically
              gap: 1.2,
            }}
          >
            <img
              src={logo}
              alt="Burj Logo"
              style={{ height: 55, borderRadius: "50%" }}
            />

            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                letterSpacing: "0.5px",
                textDecoration: "none",
                fontSize: {
                  xs: "0.85rem", // very small screens
                  sm: "0.85rem", // mobile
                  md: "1rem", // tablets and up
                  lg: "1.05rem", // desktop
                },
                display: "flex",
                alignItems: "center",
                ml: 1, // small spacing from logo
                "&:hover": {
                  color: brandBlue,
                },
              }}
            >
              Burj Al Yarmouk Industries LLC
            </Typography>
          </Box>

          {/* Desktop menu */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              gap: 3,
              alignItems: "center",
            }}
          >
            {/* ABOUT */}
            <Button
              component={RouterLink}
              to="/about-us"
              // onClick={handleMenuOpen(setAnchorAbout)}
              // endIcon={<ExpandMoreIcon />}
              sx={{
                color: brandBlue,
                fontWeight: 600,
                textTransform: "none",
                "&:hover": {
                  color: brandBlue,
                },
              }}
            >
              About
            </Button>
            {/* <Menu
              anchorEl={anchorAbout}
              open={Boolean(anchorAbout)}
              onClose={handleMenuClose(setAnchorAbout)}
            >
              <MenuItem component={RouterLink} to="/company-profile">
                Company Profile
              </MenuItem>
              <MenuItem component={RouterLink} to="/vision-mission">
                Vision & Mission
              </MenuItem>
              <MenuItem component={RouterLink} to="/certifications">
                ISO Certifications
              </MenuItem>
              <MenuItem component={RouterLink} to="/leadership">
                Leadership
              </MenuItem>
            </Menu> */}

            {/* SERVICES */}
            <Button
              component={RouterLink}
              to="/services"
              // onClick={handleMenuOpen(setAnchorServices)}
              // endIcon={<ExpandMoreIcon />}
              sx={{
                color: brandBlue,
                fontWeight: 600,
                "&:hover": {
                  color: brandBlue,
                },
              }}
            >
              Services
            </Button>
            {/* <Menu
              anchorEl={anchorServices}
              open={Boolean(anchorServices)}
              onClose={handleMenuClose(setAnchorServices)}
            >
              <MenuItem component={RouterLink} to="/acoustic-solutions">
                Acoustic Engineering
              </MenuItem>
              <MenuItem component={RouterLink} to="/metal-fabrication">
                Metal Fabrication
              </MenuItem>
              <MenuItem component={RouterLink} to="/container-conversion">
                Container Conversion
              </MenuItem>
              <MenuItem component={RouterLink} to="/construction-structures">
                Pipeline & Structures
              </MenuItem>
            </Menu> */}

            {/* PRODUCTS */}
            <Button
              component={RouterLink}
              to="/products"
              // onClick={handleMenuOpen(setAnchorProducts)}
              // endIcon={<ExpandMoreIcon />}
              sx={{
                color: brandBlue,
                fontWeight: 600,
                "&:hover": {
                  color: brandBlue,
                },
              }}
            >
              Products
            </Button>
            {/* <Menu
              anchorEl={anchorProducts}
              open={Boolean(anchorProducts)}
              onClose={handleMenuClose(setAnchorProducts)}
            >
              <MenuItem component={RouterLink} to="/generator-enclosures">
                Generator Enclosures
              </MenuItem>
              <MenuItem component={RouterLink} to="/fuel-tanks">
                Fuel Tanks
              </MenuItem>
              <MenuItem component={RouterLink} to="/stackable-tanks">
                Stackable Tanks
              </MenuItem>
              <MenuItem component={RouterLink} to="/skid-frames">
                Skid Frames
              </MenuItem>
              <MenuItem component={RouterLink} to="/pressure-vessels">
                Pressure Vessels
              </MenuItem>
            </Menu> */}

            {/* CONTACT */}
            <Button
              component={RouterLink}
              to="/contact-us"
              sx={{
                color: brandBlue,
                fontWeight: 600,
                "&:hover": {
                  color: brandBlue,
                },
              }}
            >
              Contact Us
            </Button>

            {/* MORE */}
            <Button
              onClick={handleMenuOpen(setAnchorMore)}
              endIcon={<ExpandMoreIcon />}
              sx={{
                color: brandBlue,
                fontWeight: 600,
                "&:hover": {
                  color: brandBlue,
                },
              }}
            >
              More
            </Button>
            <Menu
              anchorEl={anchorMore}
              open={Boolean(anchorMore)}
              onClose={handleMenuClose(setAnchorMore)}
            >
              {/* <MenuItem
                component={RouterLink}
                to="/projects"
                onClick={handleMenuClose(setAnchorMore)}
              >
                Projects
              </MenuItem>
              <MenuItem
                component={RouterLink}
                to="/gallery"
                onClick={handleMenuClose(setAnchorMore)}
              >
                Gallery
              </MenuItem>
              <MenuItem
                component={RouterLink}
                to="/blogs"
                onClick={handleMenuClose(setAnchorMore)}
              >
                Blogs and News
              </MenuItem> */}
              <MenuItem
                component={RouterLink}
                to="/careers"
                onClick={handleMenuClose(setAnchorMore)}
              >
                Careers
              </MenuItem>
            </Menu>

            {/* CTA BUTTON */}
            <Button
              component={RouterLink}
              to="/get-quote"
              sx={{
                backgroundColor: brandRed,
                color: "#fff",
                px: 3.5,
                py: 1.2,
                borderRadius: "45px",
                fontWeight: 700,
                display: "flex",
                alignItems: "center",
                gap: 1.2,
                boxShadow: "0 4px 12px rgba(213,0,0,0.35)",
                textTransform: "none",
                transition: "all 0.28s ease",
                "&:hover": {
                  color: "#fff",
                  backgroundColor: "#ff1a1a",
                  transform: "translateY(-3px)",
                  boxShadow: "0 8px 22px rgba(255,0,0,0.5)",
                },
              }}
            >
              Get Quote
              <ArrowForwardIosIcon sx={{ fontSize: 18 }} />
            </Button>
          </Box>

          {/* Mobile Menu Button */}
          <IconButton
            sx={{ display: { xs: "block", md: "none" }, color: brandBlue }}
            onClick={() => setDrawerOpen(true)}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* ---------------------------------------------------------------------- */}
      {/* MOBILE DRAWER */}
      {/* ---------------------------------------------------------------------- */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Box sx={{ width: 260, p: 2 }}>
          <List>
            <ListItem disablePadding>
              <ListItemButton
                component={RouterLink}
                to="/"
                onClick={() => setDrawerOpen(false)}
              >
                <HomeRounded sx={{ mr: 2, color: brandBlue }} />
                <ListItemText primary="Home" />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton
                component={RouterLink}
                to="/about-us"
                onClick={() => setDrawerOpen(false)}
              >
                <InfoRounded sx={{ mr: 2, color: brandBlue }} />
                <ListItemText primary="About Us" />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton
                component={RouterLink}
                to="/services"
                onClick={() => setDrawerOpen(false)}
              >
                <BuildRounded sx={{ mr: 2, color: brandBlue }} />
                <ListItemText primary="Services" />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton
                component={RouterLink}
                to="/products"
                onClick={() => setDrawerOpen(false)}
              >
                <Inventory2Rounded sx={{ mr: 2, color: brandBlue }} />
                <ListItemText primary="Products" />
              </ListItemButton>
            </ListItem>

            {/* <ListItem disablePadding>
              <ListItemButton
                component={RouterLink}
                to="/projects"
                onClick={() => setDrawerOpen(false)}
              >
                <BusinessCenterRounded sx={{ mr: 2, color: brandBlue }} />
                <ListItemText primary="Projects" />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton
                component={RouterLink}
                to="/gallery"
                onClick={() => setDrawerOpen(false)}
              >
                <PhotoLibraryRounded sx={{ mr: 2, color: brandBlue }} />
                <ListItemText primary="Gallery" />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton
                component={RouterLink}
                to="/blogs"
                onClick={() => setDrawerOpen(false)}
              >
                <ArticleRounded sx={{ mr: 2, color: brandBlue }} />
                <ListItemText primary="Blogs and News" />
              </ListItemButton>
            </ListItem> */}

            <ListItem disablePadding>
              <ListItemButton
                component={RouterLink}
                to="/careers"
                onClick={() => setDrawerOpen(false)}
              >
                <WorkRounded sx={{ mr: 2, color: brandBlue }} />
                <ListItemText primary="Careers" />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton
                onClick={() => setDrawerOpen(false)}
                component={RouterLink}
                to="/contact-us"
                sx={{
                  height: "100%",
                  width: "100%",
                  mt: 2,
                  border: `1px solid ${brandRed}`,
                  color: brandRed,
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1.2,
                  fontWeight: "bold",
                  textTransform: "none",
                  transition: "all 0.35s ease",
                  boxShadow: "0 3px 14px rgba(213,0,0,0.35)",

                  "&:hover": {
                    background: "linear-gradient(135deg, #d50000, #ff3333)",
                    color: "#fff",
                    transform: "translateY(-3px)",
                    boxShadow: "0 10px 24px rgba(255,0,0,0.55)",
                  },

                  "&:hover svg": {
                    color: "#fff !important",
                  },
                }}
              >
                <CallRounded
                  sx={{
                    mr: 1.5,
                    fontSize: 26,
                    transition: "color 0.3s ease",
                    color: brandRed,
                  }}
                />

                <ListItemText
                  primary="Contact Us"
                  primaryTypographyProps={{
                    sx: { fontSize: "17px", fontWeight: 700 },
                  }}
                />
              </ListItemButton>
            </ListItem>

            <ListItemButton
              onClick={() => setDrawerOpen(false)}
              component={RouterLink}
              to="/get-quote"
              sx={{
                height: "100%",
                width: "100%",
                mt: 2,
                background: brandRed,
                color: "#fff",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1.5,
                fontWeight: "bold",
                textTransform: "none",
                transition: "all 0.35s ease",
                boxShadow: "0 4px 14px rgba(213,0,0,0.38)",

                "&:hover": {
                  background: "linear-gradient(135deg, #d50000, #ff3333)",
                  color: "#fff",
                  transform: "translateY(-3px)",
                  boxShadow: "0 10px 26px rgba(255,0,0,0.55)",
                },

                "&:hover svg": {
                  color: "#fff !important",
                },
              }}
            >
              <ListItemText
                primary="Get Quote"
                primaryTypographyProps={{
                  sx: {
                    fontSize: "17px",
                    fontWeight: 700,
                    letterSpacing: "0.4px",
                    color: "#fff",
                  },
                }}
              />

              <ArrowForwardIosIcon
                sx={{
                  fontSize: 18,
                  transition: "color 0.3s ease, transform 0.3s ease",
                  color: "#fff",
                }}
              />
            </ListItemButton>
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default Navbar;
